/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 11:42:55
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-19 15:40:26
 * @name: 工单管理-保存费用
 * @Description: 工单管理-保存费用
 * @FilePath: \project\src\module\issue\validator\issueFee.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'issue_id',
    description: '工单ID',
    required: true,
    required_message: '工单ID为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'run_process_id',
    description: '工作流id',
    required: true,
    required_message: '工作流id为必传项',
    match: (e) => {
      return '';
    }
  },
]